import React from "react";

const VideoOHernPages = () => {
    return (
    <div>
        <div className="iframe-container">
            <iframe title="American Art Collector Pages Video" width="560" height="315" src="https://www.youtube.com/embed/bd8ymAhHdys?autoplay=1&origin=http://lorraineshemesh.com&modestbranding=1&rel=0" allow="fullscreen; autoplay" allowFullScreen></iframe>
        </div>
    </div>
    );
}

export default VideoOHernPages;

